<nb-action>
  <tui-icon icon="@tui.search" class="pointer" (click)="openSearch()"/>

  <div class="search" [hidden]="!search">
    <input i18n-placeholder="@@Search" [formControl]="searchControl"
           nbInput
           type="text"
           fullWidth fieldSize="small"
           (focusout)="closeSearch(true)"
           placeholder="Поиск в меню"
           [nbAutocomplete]="auto"
           #searchInput
    />
    <span class="keys">
            <kbd *ngIf="isMac"><span style="font-size: 20px">⌘</span>K</kbd>
            <kbd *ngIf="!isMac">Ctrl+K</kbd>
          </span>

    <nb-autocomplete #auto [size]="'small'" activeFirst="true">
      <nb-option *ngFor="let item of searchMatches" [value]="item" class="search-match">
        <div *ngIf="item.hasOwnProperty('parent')" class="search-match-parent-title"> {{ item.parent.title }}</div>
        <div class="search-match-title"> {{ item.title }}</div>
      </nb-option>
    </nb-autocomplete>
  </div>
</nb-action>
